import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumberWithSymbol',
  pure: true,
  standalone :false
})
export class FormatNumberWithSymbolPipe implements PipeTransform {

  transform(value: string | number): string {
    if (value === null || value === undefined) return '';

    const str = String(value).trim();
    const match = str.match(/^([^0-9.-]*)([0-9,.-]+)$/);

    if (!match) return str;

    const symbol = match[1];
    const numericPart = match[2].replace(/,/g, '');
    const number = parseFloat(numericPart);

    if (isNaN(number)) return str;

    return symbol + new Intl.NumberFormat('en-US').format(number);
  }


}
